export const serverHost = "121.196.219.178:8080";
// export const serverHost = "0.0.0.0:8888";
